import script from "./PropertyDetailsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PropertyDetailsPage.vue?vue&type=script&lang=ts&setup=true"

import "./PropertyDetailsPage.vue?vue&type=style&index=0&id=254d2e2d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-254d2e2d"]])

export default __exports__